<template>
    <div id="order-project" class="order-project image">
        <div class="overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 left">
                        <div v-scrollanimation>
                            <h3 class="main-title">
                                {{ $t('order_product.text1') }}<br /> {{ $t('order_product.text2') }}
                            </h3>
                            <p class="text">
                                {{ $t('order_product.text3') }}
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-6 right">
                        <a href="/order-product">
                            <my-button :text=" $t('order_product.order_button')" v-scrollanimation></my-button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MyButton from "@/components/MyButton.vue"
export default {
    name: "GetProduct",
    components: {
        MyButton,
    },
    data() {
        return {
        };
    },
    mounted() {  },
};
</script>

<style lang="scss">
.order-project {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: relative;
    overflow: hidden;
    color: #fff;
}

.order-project.image {
    background-image: url(../assets/img/order.webp);
    position: relative;
    // height: 70vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 80%;
}

.order-project .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #1268018a, #18223cd0);
}


.order-project .main-title {
    font-size: 40px;
    font-weight: bold;
    text-align: justify;
    // font-family: Saira, sans-serif;
}

// @font-face {
//     font-family: "Saira";
//     src: local("Saira"),
//         url(../assets/fonts/Saira-Bold.ttf) format("truetype");
// }

html:lang(ar) .order-project .text{
    font-size: 20px;
    margin-top: 20px;
}
.order-project .text {
    margin-top: 10px;
    letter-spacing: 1.5px;
    text-align: justify;
}



@media (min-width: 992px) {
    .order-project .right {
        text-align: end;
    }

    .order-project .line {
        height: 100%;
        opacity: 70%;
    }

    .order-project.image {
        height: 30%;
    }

    .order-project .overlay {
        padding: 80px 160px;
    }
}

@media (max-width: 991px) {
    .order-project .right {
        text-align: justify;
    }

    .order-project .line {
        opacity: 60%;
        height: 60%;
    }

    .order-project.image {
        height: 40%;
    }

    .order-project .overlay {
        padding: 80px 50px;
    }
    .order-project .main-title{
        font-size: 30px;
    }

}
@media (min-width: 991px) and (max-width: 767px){
    .order-project.image {
        height: 30vh;
    }
}


html:lang(en) .order-project .left .before-enter {
    opacity: 0;
    transform: translateX(-100px);
    transition: all 1s ease;
}

html:lang(ar) .order-project .left .before-enter{
    opacity: 0;
    transform: translateX(100px);
    transition: all 1s ease;
}

html:lang(ar) .order-project .left .enter, html:lang(en) .order-project .left .enter {
    opacity: 1;
    transform: translateX(0px);
}

html:lang(en) .order-project .right .before-enter {
    opacity: 0;
    transform: translateX(100px);
    transition: all 1s ease;
}

html:lang(ar) .order-project .right .before-enter {
    opacity: 0;
    transform: translateX(-100px);
    transition: all 1s ease;
}

html:lang(ar) .order-project .right .enter, html:lang(en) .order-project .right .enter {
    opacity: 1;
    transform: translateX(0px);
}

</style>
